// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post {
    background-color: white;
    font-size: 16px;
}
.post .post__loading {
    padding: 20px 0;
}
.post.shared {
    max-width: 630px;
    width: 100%;
    margin: 10px auto;
    box-shadow: none;
    border-radius: 7px;
}
.post.shared .post-image img {
    border-radius: 0 0 7px 7px;
}
.post.shared .link-preview {
    border-bottom-right-radius: 7px;
    border-bottom-left-radius: 7px;
}
.post.shared .link-preview__details {
    border-bottom-right-radius: 7px;
    border-bottom-left-radius: 7px;
}
.post .post__header {
    font-size: 14px;
    padding: 10px;
    display: grid;
    grid-template-columns: 40px auto 48px 24px;
}
.post .post__header .post__poster-image .profile-image {
    width: 100%;
    height: 100%;
}

/* These are necessary to keep the image properly sized on IOS. */
.post .post__header .post__poster-image .profile-image img {
    width: 40px;
}
.post.shared .post__header .post__poster-image .profile-image img {
    width: 40px;
    border-radius: 10000px;
}
/* End IOS fixes. */

.post .post__header .post__details {
    padding: 4px 10px;
}
.post .post__header .post__controls {
    text-align: right;
    padding-top: 3px;
    padding-right: 10px;
}

.post .post__post-visibility {
    font-size: 12px;
}
.post .post__post-visibility svg {
    width: 1.2em;
    height: 1.2em;
    margin-bottom: -0.2em;
    color: var(--primary-color-dark);
}

.post .post__content {
    padding: 0 10px 15px 10px;
    white-space: pre-line;
    word-wrap: break-word;
}
.post .post__content .post__moderated {
    font-size: 14px;
    padding: 7px;
    border-radius: 7px;
    background-color: var(--danger-color-lightest);
    border: thin solid var(--danger-color-light);
}
.post .post__show-more {
    padding: 10px;
    text-align: center;
}
.post .post__error {
    text-align: center;
    padding: 50px;
}
.post .post__error h1 {
    padding: 0 0 1em 0;
    margin: 0 auto;
}

@media (width >= 700px) {
    .post {
        border: thin solid var(--main-border-color);
        border-radius: 7px;
        padding: 0;
        width: 650px;
        margin: 20px auto;
        box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);
    }
}
@media (width < 700px) {
    .post {
        border-top: thin solid var(--main-border-color);
        border-bottom: thin solid var(--main-border-color);
        padding: 0;
        width: 100%;
        margin: 10px auto;
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/Post/Post.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;AACA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,aAAa;IACb,aAAa;IACb,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,iEAAiE;AACjE;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,sBAAsB;AAC1B;AACA,mBAAmB;;AAEnB;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;IAC9C,4CAA4C;AAChD;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,2CAA2C;QAC3C,kBAAkB;QAClB,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB,6CAA6C;IACjD;AACJ;AACA;IACI;QACI,+CAA+C;QAC/C,kDAAkD;QAClD,UAAU;QACV,WAAW;QACX,iBAAiB;IACrB;AACJ","sourcesContent":[".post {\n    background-color: white;\n    font-size: 16px;\n}\n.post .post__loading {\n    padding: 20px 0;\n}\n.post.shared {\n    max-width: 630px;\n    width: 100%;\n    margin: 10px auto;\n    box-shadow: none;\n    border-radius: 7px;\n}\n.post.shared .post-image img {\n    border-radius: 0 0 7px 7px;\n}\n.post.shared .link-preview {\n    border-bottom-right-radius: 7px;\n    border-bottom-left-radius: 7px;\n}\n.post.shared .link-preview__details {\n    border-bottom-right-radius: 7px;\n    border-bottom-left-radius: 7px;\n}\n.post .post__header {\n    font-size: 14px;\n    padding: 10px;\n    display: grid;\n    grid-template-columns: 40px auto 48px 24px;\n}\n.post .post__header .post__poster-image .profile-image {\n    width: 100%;\n    height: 100%;\n}\n\n/* These are necessary to keep the image properly sized on IOS. */\n.post .post__header .post__poster-image .profile-image img {\n    width: 40px;\n}\n.post.shared .post__header .post__poster-image .profile-image img {\n    width: 40px;\n    border-radius: 10000px;\n}\n/* End IOS fixes. */\n\n.post .post__header .post__details {\n    padding: 4px 10px;\n}\n.post .post__header .post__controls {\n    text-align: right;\n    padding-top: 3px;\n    padding-right: 10px;\n}\n\n.post .post__post-visibility {\n    font-size: 12px;\n}\n.post .post__post-visibility svg {\n    width: 1.2em;\n    height: 1.2em;\n    margin-bottom: -0.2em;\n    color: var(--primary-color-dark);\n}\n\n.post .post__content {\n    padding: 0 10px 15px 10px;\n    white-space: pre-line;\n    word-wrap: break-word;\n}\n.post .post__content .post__moderated {\n    font-size: 14px;\n    padding: 7px;\n    border-radius: 7px;\n    background-color: var(--danger-color-lightest);\n    border: thin solid var(--danger-color-light);\n}\n.post .post__show-more {\n    padding: 10px;\n    text-align: center;\n}\n.post .post__error {\n    text-align: center;\n    padding: 50px;\n}\n.post .post__error h1 {\n    padding: 0 0 1em 0;\n    margin: 0 auto;\n}\n\n@media (width >= 700px) {\n    .post {\n        border: thin solid var(--main-border-color);\n        border-radius: 7px;\n        padding: 0;\n        width: 650px;\n        margin: 20px auto;\n        box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);\n    }\n}\n@media (width < 700px) {\n    .post {\n        border-top: thin solid var(--main-border-color);\n        border-bottom: thin solid var(--main-border-color);\n        padding: 0;\n        width: 100%;\n        margin: 10px auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
